import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
const DIV_WIDTH = 800;
const DIV_HEIGHT = 1126;
const MARGIN_BOTTOM = 20;
const FOOTER_OFFSET = 15;

type ElementWrap = {
  el: Element;
  page: number;
};

const printPDF = {
  printPDFButton: document.getElementById("printPDF"),
  pdfContent: document.getElementById("pdfContent"),
  progress: document.getElementById("printProgers"),
  icon: document.getElementById("printPDFIcon"),
  loader: document.getElementById("printPDFLoader"),
  isLoading: false,
  header: (window as any).pdfHeader as string,
  footerHtml: (window as any).pdfFooter as string,
  pages: [] as ElementWrap[],
  divToPrint: null as HTMLElement | null,
  lastPageFooterHtml: (window as any).pdfLastPageFooter as string,

  init() {
    this.setprintPDF();
  },
  setprintPDF() {
    if (this.printPDFButton) {
      this.printPDFButton.addEventListener("click", async () => {
        if (!this.pdfContent || this.isLoading) return;
        this.isLoading = true;
        this.loader?.classList.remove("d-none");
        this.icon?.classList.add("d-none");

        this.createOptimizedContent();
        await this.printPDF();
        this.divToPrint?.remove();
        this.loader?.classList.add("d-none");
        this.icon?.classList.remove("d-none");
        this.isLoading = false;
      });
    }
  },
  createOptimizedContent() {
    if (!this.pdfContent) return;

    this.createPagesList(this.pdfContent);
    this.createOptimizedPages();
  },

  createPagesList(page: HTMLElement) {
    let currentPage = 1;
    const content = page.querySelectorAll(
      ".jsContent"
    ) as NodeListOf<HTMLElement>;
    const pageHeader = page.querySelector(".jsPageHeader") as HTMLElement | undefined;
  
    if(!pageHeader) return
    let currentPageHeight =
      pageHeader.offsetHeight + MARGIN_BOTTOM + FOOTER_OFFSET;

    this.pages = [
      ...this.pages,
      {
        el: pageHeader,
        page: 1,
      },
    ];

    Array.from(content).forEach((element, index) => {
      const children = Array.from(element.childNodes).filter(
        (node): node is HTMLElement =>
          (node as Node).nodeType === Node.ELEMENT_NODE  && (node as HTMLElement).tagName !== 'STYLE'
      );
      if(index > 0){
        currentPage++;
        currentPageHeight = FOOTER_OFFSET;
      }
     
      children.forEach((el) => {
        const elementHeight = el.offsetHeight + MARGIN_BOTTOM;
       
        if (currentPageHeight + elementHeight > DIV_HEIGHT) {
          currentPage++;
          this.pages = [
            ...this.pages,
            {
              el: el,
              page: currentPage,
            },
          ];

          currentPageHeight = elementHeight + FOOTER_OFFSET;
        } else {
          this.pages = [
            ...this.pages,
            {
              el: el,
              page: currentPage,
            },
          ];
          currentPageHeight += elementHeight;
        }
      });
    });
    
    this.pages = [
      ...this.pages,
      {
        el: this.createLastPage(currentPage + 1),
        page: currentPage + 1,
      },
    ];
  },
  addPageNumber(page: number) {
    const div = document.createElement("p");
    div.classList.add("printable-popup__page-num");
    div.innerHTML = `page <b>${page}</b>`;
    return div;
  },
  createOptimizedPages() {
    try {
      let currentPageNum = 1;
      let currentPage = this.createNewPage();
      currentPage.offsetHeight;
      const div = document.createElement("div");
      div.classList.add("pdf-div");
      div.appendChild(currentPage);

      this.pages.forEach((page) => {
        if (page.page > currentPageNum) {
          const footer = this.addPageNumber(currentPageNum);
          currentPage.appendChild(footer.cloneNode(true));

          currentPage = this.createNewPage();
          currentPage.offsetHeight;
          div.appendChild(currentPage);
          currentPageNum++;
        }
        currentPage.appendChild(page.el.cloneNode(true));
      });

      document.body.append(div);
      this.divToPrint = div;
    } catch (error) {
      console.error("Error in createOptimizedPages:", error);
    }
  },

  createNewPage() {
    const newPage = document.createElement("div");
    newPage.classList.add(
      "single-print-page",
      "jsPage",
      "single-print-page-title-center"
    );
    newPage.style.minHeight = DIV_HEIGHT + "px";
    newPage.style.height = DIV_HEIGHT + "px";
    newPage.style.overflow = "hidden";
    newPage.style.pageBreakAfter = "always";
    return newPage;
  },

  createLastPage(num: number) {
    const footerBottom = document.createElement("div");
    const pageHtml = this.addPageNumber(num);
    footerBottom.innerHTML = this.footerHtml;
    footerBottom.appendChild(pageHtml);
    return footerBottom;
  },

  async printPDF() {
    if (!this.divToPrint) return;
    const pdfWidth = 595;
    const pdfHeight = 842;

    const padding = 10;
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [pdfWidth, pdfHeight],
    });

    const pages = this.divToPrint.querySelectorAll(".jsPage");
    const pagesCount = pages.length;
    if (this.progress) {
      this.progress.innerText = `generating pages 0 / ${pagesCount}`;
    }

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i] as HTMLElement;

      const canvas = await html2canvas(page, {
        scale: 2,
        scrollX: 0,
        scrollY: 0,
        windowWidth: page.scrollWidth,
        windowHeight: page.scrollHeight,
      });
      if (this.progress) {
        this.progress.innerText = `generating pages ${i + 1} / ${pagesCount}`;
      }

      const imgData = canvas.toDataURL("image/webp");
      const imgWidth = pdfWidth - 2 * padding;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;

      pdf.addImage(imgData, "PNG", padding, padding, imgWidth, imgHeight);

      if (i < pages.length - 1) {
        pdf.addPage([pdfWidth, pdfHeight]);
      }
    }

    const title = (this.pdfContent?.dataset.title || "document") + ".pdf";
    pdf.save(title);
    if (this.progress) {
      this.progress.innerText = "done";
    }
    setTimeout(() => {
      if (this.progress) {
        this.progress.innerText = "";
      }
    }, 2000);
  },
};

export default printPDF;
